// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { AttributeTypeModel } from "@insite/client-framework/Types/ApiModels";

const getAttributeTypeValue = (attribute: string, attributeTypes: AttributeTypeModel[] | undefined) => {
    const attributeType = attributeTypes?.find(type => type.name === attribute);

    if (!attributeType || !attributeType.attributeValues?.length) {
        return translate("N/A");
    }

    const displayValues = attributeType.attributeValues.map(value => value.valueDisplay).filter(Boolean);

    return displayValues.length ? displayValues.join(", ") : translate("N/A");
};

export default getAttributeTypeValue;
